import React from 'react';
import { PageWrapper } from '../../components/modules/wrapper';
import WillFormView from './WillFormView';

export const WillFormContainer = () => {
  return (
    <PageWrapper>
      <WillFormView />
    </PageWrapper>
  );
};
